import { Typography } from "components/parts/Typography/Typography";
import styled from "styled-components";

export const StyledForm = styled.form`
  height: 100%;
  width: 30rem;
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
`;

export const StyledModalHeader = styled.div`
  margin: auto;
`;

export const StyledTitle = styled(Typography)`
  margin: auto;
  min-height: 1em;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 1rem;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 2rem;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

export const StyledButtonArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  column-gap: 1rem;
`;

export const StyledMediaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
